// extracted by mini-css-extract-plugin
export default {"container":"styles_container__PRsrN","logo":"styles_logo__tYHus","formBody":"styles_formBody__fwwb0","formFooter":"styles_formFooter__fHZeH"};